<template>
  <section class="case-section" id="service">
    <div class="case-container">
      <div class="case-heading">
        <div>
          <div class="section-eyebrow">Applied cases</div>
          <h2 class="section-title">典型增值改造案例</h2>
        </div>
        <p>
          根据设备现状、现场环境与工艺需求，提供功能提升、环境优化和稳定性增强等定制化改造方案，帮助客户提升设备使用价值。
        </p>
      </div>

      <div class="case-layout">
        <article class="main-case">
          <div class="main-case-media">
            <ZoomableImage
              :src="require('@/assets/images/custom/image28.png')"
              alt="加装功能提升设备加工能力"
              fit="cover"
            />
          </div>
          <div class="main-case-copy">
            <div class="case-tag">能力提升</div>
            <h3>加装功能提升设备加工能力</h3>
            <p>
              根据客户设备现状和加工工艺要求，进行调研、评估与方案评审，增加主轴摆动、回转工作台等功能，
              使原有设备更贴合新的加工任务。
            </p>
            <ul>
              <li>增加主轴摆动功能，摆动角度可按工艺要求配置。</li>
              <li>增加水平放置回转工作台（C 轴），提升加工灵活性。</li>
              <li>拆装主轴组件并调整相关参数，避免无关报警影响生产。</li>
            </ul>
          </div>
        </article>

        <div class="side-cases">
          <article class="case-card" v-for="item in cases" :key="item.title">
            <div class="case-card-media">
              <ZoomableImage :src="getImage(item)" :alt="item.title" :fit="item.fit" />
            </div>
            <div class="case-card-copy">
              <div class="case-tag">{{ item.tag }}</div>
              <h3>{{ item.title }}</h3>
              <p>{{ item.desc }}</p>
            </div>
          </article>
        </div>
      </div>

      <div class="case-principles">
        <div class="principle" v-for="(item, idx) in principles" :key="idx">
          <span>{{ idx + 1 }}</span>
          <div>
            <strong>{{ item.title }}</strong>
            <p>{{ item.desc }}</p>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import ZoomableImage from './ZoomableImage.vue';

export default {
  name: 'CustomerSection',
  components: {
    ZoomableImage
  },
  data() {
    return {
      cases: [
        {
          tag: '环境优化',
          title: '油雾收集器加装',
          desc: '降低车间油雾弥漫和设备腐蚀风险，同时兼顾环保要求与现场维护便利性。',
          base: 'gallery',
          img: 'oil-mist-line.jpg',
          fit: 'cover'
        },
        {
          tag: '稳定性提升',
          title: '电柜空调加装',
          desc: '降低电柜运行温度，保护电器元器件，提高设备长期运行稳定性。',
          base: 'custom',
          img: 'image30.png',
          fit: 'cover'
        },
        {
          tag: '精度稳定',
          title: '切屑液恒温装置',
          desc: '保持切屑液温度稳定，减少温度波动对产品尺寸稳定性的影响。',
          base: 'custom',
          img: 'image31.png',
          fit: 'cover'
        }
      ],
      principles: [
        {
          title: '先评估，再改造',
          desc: '基于设备状态、现场条件和加工需求确定改造边界。'
        },
        {
          title: '不破坏主机稳定性',
          desc: '加装方案尽量与主机控制逻辑清晰分离，降低引入新故障的风险。'
        },
        {
          title: '交付可验证',
          desc: '改造后通过调试、运行确认和参数记录完成闭环交付。'
        }
      ]
    };
  },
  methods: {
    getImage(item) {
      return require('@/assets/images/' + item.base + '/' + item.img);
    }
  }
};
</script>

<style scoped>
.case-section {
  background: #ffffff;
  padding: 88px 0;
}

.case-container {
  max-width: 1240px;
  margin: 0 auto;
  padding: 0 24px;
}

.case-heading {
  display: grid;
  grid-template-columns: 0.8fr 1fr;
  gap: 36px;
  align-items: end;
  margin-bottom: 28px;
}

.section-eyebrow {
  color: #1976d2;
  font-size: 0.88rem;
  font-weight: 900;
  letter-spacing: 1.5px;
  text-transform: uppercase;
  margin-bottom: 10px;
}

.section-title {
  margin: 0;
  color: #132033;
  font-size: 2.2rem;
  font-weight: 900;
  letter-spacing: 1px;
}

.case-heading p {
  margin: 0;
  color: #536173;
  line-height: 1.9;
}

.case-layout {
  display: grid;
  grid-template-columns: minmax(0, 1.1fr) minmax(360px, 0.9fr);
  gap: 18px;
}

.main-case,
.case-card {
  border: 1px solid #e8eef6;
  background: #ffffff;
  box-shadow: 0 16px 40px rgba(16, 35, 64, 0.06);
}

.main-case {
  border-radius: 26px;
  overflow: hidden;
}

.main-case-media {
  height: 360px;
  background: #f8fafc;
  border-bottom: 1px solid #e8eef6;
}

.main-case-copy {
  padding: 24px;
}

.case-tag {
  display: inline-flex;
  color: #1976d2;
  background: rgba(25, 118, 210, 0.09);
  border-radius: 999px;
  padding: 5px 10px;
  font-size: 0.82rem;
  font-weight: 900;
  margin-bottom: 12px;
}

.main-case h3,
.case-card h3 {
  margin: 0 0 10px;
  color: #132033;
  font-weight: 900;
}

.main-case p,
.case-card p {
  margin: 0;
  color: #536173;
  line-height: 1.85;
}

.main-case ul {
  margin: 14px 0 0;
  padding-left: 18px;
  color: #536173;
  line-height: 1.8;
}

.side-cases {
  display: grid;
  gap: 18px;
}

.case-card {
  display: grid;
  grid-template-columns: 180px 1fr;
  border-radius: 20px;
  overflow: hidden;
}

.case-card-media {
  min-height: 190px;
  background: #f8fafc;
  border-right: 1px solid #e8eef6;
}

.case-card-copy {
  padding: 18px;
}

.case-principles {
  margin-top: 20px;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 14px;
}

.principle {
  display: flex;
  gap: 12px;
  align-items: flex-start;
  background: #f7faff;
  border: 1px solid #e8eef6;
  border-radius: 18px;
  padding: 16px;
}

.principle span {
  flex: 0 0 auto;
  width: 34px;
  height: 34px;
  border-radius: 12px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: #1976d2;
  color: #ffffff;
  font-weight: 900;
}

.principle strong {
  display: block;
  color: #132033;
  margin-bottom: 6px;
}

.principle p {
  margin: 0;
  color: #536173;
  line-height: 1.7;
  font-size: 0.94rem;
}

@media (max-width: 1024px) {
  .case-heading,
  .case-layout,
  .case-principles {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 768px) {
  .case-section {
    padding: 60px 0;
  }

  .section-title {
    font-size: 1.75rem;
  }

  .main-case-media {
    height: 260px;
  }

  .case-card {
    grid-template-columns: 1fr;
  }

  .case-card-media {
    border-right: 0;
    border-bottom: 1px solid #e8eef6;
  }
}
</style>
